import { RouteItem } from '@eastcoal/router/types/route'

import { LISTING_LIST_PAGE_UUID } from './uuid'

export const listingListRoute: RouteItem = {
  title: '挂牌列表',
  path: '/listing/list',
  uuid: LISTING_LIST_PAGE_UUID,
  Component: () => import('./index')
}
